export default [
  {
    path: '/active-hhxd/index',
    name: 'index',
    component: () => import('@/views/active-hhxd/index'),
    meta: {
      title: '赢战新学期，我是行动派-高考直通车',
      content:'学海无涯，来抽上岸盲盒！更有时间管理器+惊喜礼盒轻松拿，马上报名行动派>>'
    }
  },{
    path: '/active-hhxd/detail',
    name: 'detail',
    component: () => import('@/views/active-hhxd/detail'),
    meta: {
      title: '赢战新学期，我是行动派-高考直通车',
      content:'学海无涯，来抽上岸盲盒！更有时间管理器+惊喜礼盒轻松拿，马上报名行动派>>'
    }
  }
]
